import type { TypeSelectOption } from '@thefarmersfront/kitchen';

import { transformToSelectOptions } from '~/utils';

import type { TypeProductCodeName } from '~/types/product.types';

/**
 * @description
 * 상품관리 > select 에서 사용하는 ENUM 값 code-name 페어를 kitchen의 select option에 맞게 형변환을 하는 함수
 */

const transformToProductSelectOptions = (arr: TypeProductCodeName[]): TypeSelectOption<string>[] => {
  return transformToSelectOptions(arr, 'code', 'name');
};

export default transformToProductSelectOptions;
